import { useFormContext } from 'react-hook-form';

import InputForm from 'shared/components/Input/InputForm';
import { FieldTypesE } from 'shared/models/fields';
import { SourcesFormFieldT } from 'shared/models/sources-form';
import jsonObj from 'utils/objects';

type SourcesFormFieldRenderProps = {
  field: SourcesFormFieldT,
  isSpecific?: boolean;
}
function SourcesFormFieldRender({ field, isSpecific }: SourcesFormFieldRenderProps) {
  const {
    register,
    getValues,
    control,
    formState: {
      errors,
    },
  } = useFormContext();
  const fieldName = isSpecific ? `specific.${field.name}` : field.name;
  const key = fieldName;
  const error = jsonObj.getDescendantProp(errors, fieldName);

  switch (field.type) {
    case FieldTypesE.TEXT:
      return (
        <InputForm.TextField
          fullWidth
          sx={{ mt: 1, mb: 1 }}
          key={key}
          label={field.displayName}
          register={register(fieldName)}
          errorField={error}
          helperText={field.comment}
          disabled={field.disabled}
          shrinkLabel
        />
      );
    case FieldTypesE.TEXT_MULTILINES:
      return (
        <InputForm.TextField
          multiline
          maxRows={4}
          fullWidth
          sx={{ mt: 1, mb: 1 }}
          key={key}
          label={field.displayName}
          register={register(fieldName)}
          errorField={error}
          helperText={field.comment}
          disabled={field.disabled}
          shrinkLabel
        />
      );
    case FieldTypesE.NUMBER:
      return (
        <InputForm.TextField
          fullWidth
          sx={{ mt: 1, mb: 1 }}
          key={key}
          label={field.displayName}
          register={register(fieldName, {
            pattern: {
              value: /^[1-9]\d*(\d+)?$/i,
              message: 'Please enter an integer',
            },
          })}
          errorField={error}
          helperText={field.comment}
          disabled={field.disabled}
          shrinkLabel
        />
      );
    case FieldTypesE.CHECKBOX:
      return (
        <InputForm.Checkbox
          sx={{ ml: 0.5, mb: 0.5 }}
          key={key}
          name={fieldName}
          control={control}
          label={field.displayName}
          defaultChecked={getValues(fieldName)}
          helpText={field.comment}
        />
      );
    default:
      return null;
  }
}

export default SourcesFormFieldRender;
